import React from "react";
import styles from "./Separator.module.css";

const Separator = ({ direction, style, className = "" }) => {
  const separatorClass =
    direction === "horizontal"
      ? `${styles.horizontal} ${className}`
      : `${styles.vertical} ${className}`;

  const containerClass =
    direction === "horizontal" ? styles["separator-container"] : "";

  return (
    <div className={containerClass} style={style}>
      <div className={separatorClass}></div>
    </div>
  );
};

export default Separator;
